<template>
	<div class="basic_wrap">
		<div class="lan-box">
			<van-popover
			  v-model="showPopover"
			  trigger="click"
			  placement="bottom-start"
			  :offset="[0, 0]"
			  :actions="actions"
			  @select="onSelect"
			>
			  <template #reference>
				<div class="lan-label">
					<img :src="lan_ico" alt="">
					<span >{{lan_num}}</span>
				</div>
			  </template>
			</van-popover>
		</div>
		<div class="user-top">
			<img src="../images/login/logo.png" alt="">
			<div class="user-name">B2B</div>
		</div>
		<div class="login-main">
			<form class="form">
				<div class="cut_login">
					<router-link to="/login">
						{{$t('register.signIn')}}
						<div class="line" />
					</router-link>
					<router-link class="cur" to="/register">
						{{$t('register.signUp')}}
						<div class="line" />
					</router-link>
				</div>

				<!-- 注册方式切换 -->
				<div class="reg-type-switch">
					<div :class="['reg-type-item', regType === 'email' ? 'active' : '']" @click="switchRegType('email')">
						{{$t('register.regTypeEmail')}}
					</div>
					<div :class="['reg-type-item', regType === 'phone' ? 'active' : '']" @click="switchRegType('phone')">
						{{$t('register.regTypePhone')}}
					</div>
				</div>

				<!-- 邮箱输入 -->
				<div v-if="regType === 'email'" class="item mt" style="padding-left: 10px;">
					<span class="icon">
						<img src="../images/login/email.png" alt="">
					</span>
					<input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('register.phoneNumber')">
				</div>

				<!-- 手机号输入 -->
				<div v-if="regType === 'phone'" class="item mt phone-item">
					<div class="country-code-btn" @click="showCountryPicker = true">
						<span class="country-flag">{{ selectedCountry.flag }}</span>
						<span class="country-dial">{{ selectedCountry.code }}</span>
						<span class="arrow-down">▾</span>
					</div>
					<div class="divider-line"></div>
					<input v-model.trim="phoneNum" type="tel" class="inp" :placeholder="$t('register.phoneInput')">
				</div>

				<div class="item" style="padding-left: 10px;">
					<span class="icon">
						<img src="../images/login/lock.png" alt="">
					</span>
					<input v-model.trim="data.password" :type="password" class="inp"
						:placeholder="$t('register.password')">
					<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
				</div>

				<div v-if="regType === 'email' && show_sms > 0" class="item">
					<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
					<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
						<template v-slot="timeData">
							<span @click="sendcode">{{
              timeData.seconds > 0
                ? timeData.seconds
                : $t('register.sendCode')
            }}</span>
						</template>
					</van-count-down>
				</div>

				<div class="item">
					<span class="icon">
						<img src="../images/login/p2.png" class="people" alt="">
					</span>
					<input v-model.trim="data.t_mobile" type="text" class="inp" maxlength="6"
						style="text-transform:uppercase;"
						@input="data.t_mobile = data.t_mobile.toUpperCase()"
						:placeholder="$t('register.referralCode')">
				</div>
				<div class="basic_btn sbtn" :class="submitDisabled ? 'no_touch' : ''" @click="submit">
					{{$t('register.signUpBtn')}}
				</div>
			</form>
		</div>

		<!-- 国家区号选择器弹窗 -->
		<van-popup v-model="showCountryPicker" position="bottom" class="country-popup">
			<div class="country-picker-header">
				<span>{{ $t('register.selectCountry') }}</span>
				<span class="cp-close" @click="closeCountryPicker">✕</span>
			</div>
			<div class="country-search">
				<input
					v-model="searchQuery"
					type="text"
					class="country-search-input"
					:placeholder="$t('register.searchCountry')"
				>
			</div>
			<div class="country-list">
				<div
					v-for="(item, index) in filteredCountries"
					:key="index"
					class="country-item"
					:class="{ 'country-item--active': selectedCountry.code === item.code }"
					@click="onCountryConfirm(item)"
				>
					<span class="ci-flag">{{ item.flag }}</span>
					<span class="ci-name">{{ item.name }}</span>
					<span class="ci-code">{{ item.code }}</span>
					<span v-if="selectedCountry.code === item.code" class="ci-check">✓</span>
				</div>
			</div>
		</van-popup>

		<van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="privacyStatementHide">
		</van-dialog>
		<van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="agreementHider">
		</van-dialog>
		<div v-if="msg_show" class="kefu-link" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../../views/images/user/kefu-ico.png">
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		CountDown,
		Checkbox,
		Dialog,
		Popup
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(CountDown)
		.use(Checkbox)
		.use(Dialog)
		.use(Popup);

	const COUNTRIES = [
		{ flag: '🇨🇳', name: '中国', code: '+86' },
		{ flag: '🇭🇰', name: '香港', code: '+852' },
		{ flag: '🇹🇼', name: '台灣', code: '+886' },
		{ flag: '🇺🇸', name: 'United States', code: '+1' },
		{ flag: '🇬🇧', name: 'United Kingdom', code: '+44' },
		{ flag: '🇦🇺', name: 'Australia', code: '+61' },
		{ flag: '🇸🇬', name: 'Singapore', code: '+65' },
		{ flag: '🇯🇵', name: '日本', code: '+81' },
		{ flag: '🇰🇷', name: '한국', code: '+82' },
		{ flag: '🇹🇭', name: 'ประเทศไทย', code: '+66' },
		{ flag: '🇲🇾', name: 'Malaysia', code: '+60' },
		{ flag: '🇻🇳', name: 'Việt Nam', code: '+84' },
		{ flag: '🇧🇷', name: 'Brasil', code: '+55' },
		{ flag: '🇵🇭', name: 'Pilipinas', code: '+63' },
		{ flag: '🇮🇩', name: 'Indonesia', code: '+62' },
		{ flag: '🇮🇳', name: 'भारत', code: '+91' },
		{ flag: '🇫🇷', name: 'France', code: '+33' },
		{ flag: '🇮🇹', name: 'Italia', code: '+39' },
		{ flag: '🇸🇦', name: 'السعودية', code: '+966' },
		{ flag: '🇦🇪', name: 'الإمارات', code: '+971' },
		{ flag: '🇪🇬', name: 'مصر', code: '+20' },
		{ flag: '🇰🇼', name: 'الكويت', code: '+965' },
		{ flag: '🇶🇦', name: 'قطر', code: '+974' },
	];

	export default {
		name: "Register",
		data() {
			return {
				time: 0,
				agreement: false,
				statement: false,
				show_kefu: false,
				msg_show: true,
				show_sms: 0,
				password: "password",
				regType: 'email',
				phoneNum: '',
				showCountryPicker: false,
				searchQuery: '',
				selectedCountry: COUNTRIES.find(c => c.code === '+1'),
				data: {
					password: "",
					spassword: "",
					mobile: "",
					t_mobile: "",
					code: "",
					agent: 10000
				},
				showPopover: false,
				actions: [
					{ text: '中国' ,icon: require('../images/language/zh_cn.png') ,},
					{ text: 'English' ,icon: require('../images/language/en_us.png') ,},
					{ text: '日本' ,icon: require('../images/language/ja_jp.png') ,},
					{ text: '한국어' ,icon: require('../images/language/ko_kr.png') ,},
					{ text: 'Việt Nam' ,icon: require('../images/language/vi_vn.png') ,},
					{ text: 'ภาษาไทย' ,icon: require('../images/language/th_th.png') ,},
					{ text: 'Malaysia' ,icon: require('../images/language/ms_my.png') ,},
					{ text: '繁體中文' ,icon: require('../images/language/zh_hk.png') ,},
					{ text: 'Deutsch' ,icon: require('../images/language/de_de.svg') ,},
					{ text: 'Español' ,icon: require('../images/language/es_es.svg') ,},
					{ text: 'Português (BR)' ,icon: require('../images/language/pt_br.svg') ,},
					{ text: 'العربية' ,icon: require('../images/language/ar_sa.svg') ,},
					{ text: 'Italiano' ,icon: require('../images/language/it_it.svg') ,},
					{ text: 'Français' ,icon: require('../images/language/fr_fr.svg') ,},
					{ text: 'Indonesia' ,icon: require('../images/language/id_id.svg') ,},
					{ text: 'हिन्दी' ,icon: require('../images/language/hi_in.svg') ,},
				],
				lan_num:'中国',
				lan_ico:require('../images/language/zh_cn.png'),
				config: {}
			};
		},
		computed: {
			countries() {
				return COUNTRIES;
			},
			filteredCountries() {
				if (!this.searchQuery) return COUNTRIES;
				const q = this.searchQuery.toLowerCase();
				return COUNTRIES.filter(c =>
					c.name.toLowerCase().includes(q) || c.code.includes(q)
				);
			},
			submitDisabled() {
				if (this.regType === 'phone') {
					return !this.phoneNum || !this.data.password;
				}
				return !this.data.mobile || !this.data.password;
			}
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
		},
		mounted() {
			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			Fetch('/index/webconfig', {
				type: 'web'
			}).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
		},
		methods: {
			onSelect(action) {
				console.log(action)
				this.lan_ico = action.icon
				this.lan_num = action.text
				let lang
				if (action.text == "中国") {
					lang = "zh_cn"
				}
				if (action.text == "English") {
					lang = "en_us"
				}
				if (action.text == "日本") {
					lang = "ja_jp"
				}
				if (action.text == "한국어") {
					lang = "ko_kr"
				}
				if (action.text == "Việt Nam") {
					lang = "vi_vn"
				}
				if (action.text == "ภาษาไทย") {
					lang = "th_th"
				}
				if (action.text == "Malaysia") {
					lang = "ms_my"
				}
				if (action.text == "繁體中文") {
					lang = "zh_hk"
				}
				if (action.text == "Deutsch") {
					lang = "de_de"
				}
				if (action.text == "Español") {
					lang = "es_es"
				}
				if (action.text == "Português (BR)") {
					lang = "pt_br"
				}
				if (action.text == "العربية") {
					lang = "ar_sa"
				}
				if (action.text == "Italiano") {
					lang = "it_it"
				}
				if (action.text == "Français") {
					lang = "fr_fr"
				}
				if (action.text == "Indonesia") {
					lang = "id_id"
				}
				if (action.text == "हिन्दी") {
					lang = "hi_in"
				}
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
			},
			switchRegType(type) {
				this.regType = type;
				this.data.mobile = '';
				this.phoneNum = '';
			},
			onCountryConfirm(value) {
				this.selectedCountry = value;
				this.showCountryPicker = false;
				this.searchQuery = '';
			},
			closeCountryPicker() {
				this.showCountryPicker = false;
				this.searchQuery = '';
			},
			kefu_to() {
				this.$router.push("/kefu");
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				var info = JSON.parse(info);
				console.log(info);
				if (info.code == 0) {
					this.data.oaid = info.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				this.data.t_mobile = m;
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				const mobile = this.regType === 'phone'
					? this.selectedCountry.code + this.phoneNum
					: this.data.mobile;

				if (!mobile) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
						mobile: mobile,
					})
					.then(() => {
						this.time = 60 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				if (this.regType === 'phone') {
					if (!this.phoneNum) {
						this.$toast({
							className: "toastName",
							message: this.$t('register.phoneInputEmpty'),
						});
						return false;
					}
					this.data.mobile = this.selectedCountry.code + this.phoneNum;
				} else {
					if (!this.data.mobile) {
						this.$toast({
							className: "toastName",
							message: this.$t('register.phoneEmpty'),
						});
						return false;
					}
				}

				if (!this.data.password) {
					this.$toast({
						className: "toastName",
						message: this.$t('register.passwordEmpty'),
					});
					return false;
				}

				if (!this.data.code && this.config.sms_verify && this.regType === 'email') {
					this.$toast({
						className: "toastName",
						message: this.$t('register.codeEmpty'),
					});
					return false;
				}

				Fetch("/index/register", {
					...this.data,
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast({
						className: "toastName",
						message: this.$t('register.signUpSuccess'),
					});
					this.$router.replace("/");
				});
			},
			userAgreement() {
				this.agreement = true;
			},
			agreementHider() {
				this.agreement = false;
			},
			privacyStatement() {
				this.statement = true;
			},
			privacyStatementHide() {
				this.statement = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	.user-top{
		text-align: center;
		padding: 90px 0 50px 0;
		color: #ffffff;
		img{
			width: 60px;
			height: 60px;
			border-radius: 60px;
			border: 2px solid #ffffff;
		}
		.user-name{
			font-size: 16px;
			margin-top: 10px;
		}
	}
	.basic_wrap{
		position: relative;
		background: url(../images/login/login_bg.png) no-repeat center top;
		background-size: contain;
		.lan-box{
			position: absolute;
			top: 10px;
			left:25px;
		}
	}


.login_bg {
    width: 100%;
    overflow: hidden;
	.language{
		position: absolute;
		top: 4px;
		right: 0;
		height: 36px;
		img{
			height: 100%;
		}
	}
}
.login-main{
	padding: 0 25px;
}
.basic_wrap .form {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 31px 24px 24px 24px;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #ceced0;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #f12211;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #f12211, #f18a11);
        }
    }
}

.reg-type-switch {
    display: flex;
    align-items: center;
    margin: 16px 0 12px 0;
    background-color: #ebebeb;
    border-radius: 10px;
    padding: 4px;

    .reg-type-item {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        padding: 10px 0;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.2s, color 0.2s, box-shadow 0.2s;

        &.active {
            color: #fff;
            font-weight: 700;
            background-image: linear-gradient(to right, #f12211, #f18a11);
            box-shadow: 0 2px 8px rgba(241, 34, 17, 0.35);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height:48px;
	padding: 0 15px;
    border: 1px solid #dfdfdf;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
	margin-bottom: 15px;
    .icon {
		width: 20px;
        min-width: 20px;
		text-align: center;
        height: 20px;

        img {
            width: 20px;
            height: 20px;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
    }
}

.phone-item {
    padding: 0 !important;

    .country-code-btn {
        display: flex;
        align-items: center;
        padding: 0 4px 0 8px;
        cursor: pointer;
        white-space: nowrap;
        height: 100%;

        .country-flag {
            font-size: 16px;
            margin-right: 2px;
        }

        .country-dial {
            font-size: 14px;
            color: #333;
        }

        .arrow-down {
            font-size: 12px;
            color: #999;
            margin-left: 2px;
        }
    }

    .divider-line {
        width: 1px;
        height: 20px;
        background-color: #dfdfdf;
        margin: 0 6px;
        flex-shrink: 0;
    }

    input {
        height: 20px;
        flex: 1;
        margin-left: 0;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: #3d96ff;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}
.van-checkbox{
	margin-top: 20px;
}
/deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #ff5a50;
    border-color: #ff5a50;
}
/deep/ .van-checkbox__label{
	color: #ff5a50;
}
.reset_pwd{
	color: #333;
	margin-top: -20px;
	display: block;
}

.basic_btn {
    margin:30px auto 0 auto;
}
.lan-label{
	display: flex;
	align-items: center;
	white-space: nowrap;
	height: 48px;
	min-width: 24px;
	height: 25px;
	padding-right: 8px;
	border-radius: 25px;
	background-image: linear-gradient(to right, #ffff80 , #ffffff);
}
.lan-label span{
	display: inline-block;
	margin-left: 3px;
}
.lan-label img{
	width: 22px;
	height: 22px;
}
.kefu-link{
	padding: 20px;
	text-align: center;
}
.kefu-link img{
	width: 35px;
}
.show-body{
	padding: 30px 30px 15px 30px;
	text-align: center;
}

</style>
<style>
	.van-popover{
		width:120px;
	}
	.van-popover__action{
		height: 40px;
		line-height: 40px;
	}
	.van-popover .van-popover__action-text::after{
		left: -100px;
	}
	.van-popover__action-icon{
		border: 1px solid #ececec;
		border-radius: 30px;
	}
	.van-popover__action{
		padding: 0 10px;
	}
	.country-search {
		padding: 8px 12px;
		background: #fff;
		border-bottom: 1px solid #f2f2f2;
	}
	.country-search-input {
		width: 100%;
		height: 34px;
		background: #f5f5f5;
		border: none;
		border-radius: 6px;
		padding: 0 12px;
		font-size: 14px;
		color: #333;
		box-sizing: border-box;
		outline: none;
	}
	.country-search-input::placeholder {
		color: #bbb;
	}
	.country-popup {
		border-radius: 12px 12px 0 0;
		overflow: hidden;
	}
	.country-picker-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 14px 16px 12px;
		font-size: 15px;
		font-weight: 500;
		color: #333;
		border-bottom: 1px solid #f2f2f2;
	}
	.cp-close {
		font-size: 18px;
		color: #bbb;
		cursor: pointer;
		padding: 0 4px;
		line-height: 1;
	}
	.country-list {
		max-height: 55vh;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}
	.country-item {
		display: flex;
		align-items: center;
		padding: 12px 16px;
		border-bottom: 1px solid #f5f5f5;
		cursor: pointer;
	}
	.country-item--active {
		background-color: #fff8f7;
	}
	.ci-flag {
		font-size: 20px;
		width: 30px;
		flex-shrink: 0;
	}
	.ci-name {
		flex: 1;
		font-size: 14px;
		color: #333;
	}
	.ci-code {
		font-size: 14px;
		color: #888;
		margin-right: 6px;
	}
	.ci-check {
		color: #f12211;
		font-size: 15px;
		font-weight: bold;
	}

</style>
